import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import Camera from "../../assets/svg/Camera.svg";
import AddPhoto from "../../assets/svg/AddPhoto.svg";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { TextField } from "@mui/material";
import { toast } from "react-toastify";
import { AddOutlined, DeleteOutline, EditOutlined } from "@mui/icons-material";
import DeleteModal from "../../components/Modals/DeleteModal";
import NotFound from "../../components/SharedModule/NotFound";
import { useNavigate } from "react-router";
import "./Categories.css";
import { useSelector } from "react-redux";

export default function Categories() {
  // categories

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const [addMainCatigory, setAddMainCatigory] = useState({
    image: "",
    description: "",
    name: "",
    status: "",
  });

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setAddMainCatigory({
      image: "",
      fileUrl: "",
      name: "",
      description: "",
      status: "",
    });
    setIsEditing(false);
    setEditCategoryId(null);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setIsEditing(false);
    setEditCategoryId(null);
    setIsSubCategory(false);
    setParentId(null);
  };

  const [categories, setCategories] = useState([]);

  const getCategories = async () => {
    try {
      let response = await axios.get(`${newBaseUrl}/api/portal/categories`, {
        headers,
      });
      console.log(response.data.data.categories);
      setCategories(response.data.data.categories);
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmitAddMainCatogiry = () => {
    const headers = {
      Authorization: "Bearer " + token,
    };

    const formData = new FormData();

    if (isEditing) {
      formData.append("_method", "PATCH");
    }

    if (isSubCategory) {
      formData.append("parent_id", parentId);
    }

    if (!isEditing) {
      if (addMainCatigory.image instanceof File) {
        formData.append("image", addMainCatigory.image);
      } else {
        toast.error("Please upload a valid image for the icon.");
        return;
      }
    } else {
      if (addMainCatigory.imag instanceof File) {
        formData.append("image", addMainCatigory.image);
      }
    }

    formData.append("name", addMainCatigory.name);
    formData.append("description", addMainCatigory.description);
    formData.append("status", addMainCatigory.status);

    const url = isEditing
      ? `${newBaseUrl}/api/portal/categories/${editCategoryId}`
      : `${newBaseUrl}/api/portal/categories`;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isEditing
            ? "Category Updated Successfully"
            : isSubCategory
            ? "Subcategory Added Successfully"
            : "Main Category Added Successfully",
          { autoClose: 3000 }
        );
        setShow(false);
        setIsEditing(false);
        setIsSubCategory(false);
        getCategories();
        setAddMainCatigory({
          icon_url: "",
          description: "",
          name: "",
          status: "",
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const [isEditing, setIsEditing] = useState(false);

  const [editCategoryId, setEditCategoryId] = useState(null);

  const handleEditCategory = (category) => {
    console.log(category);

    const fullImageUrl = category?.image_url?.startsWith("http")
      ? category.image_url
      : category?.image_url
      ? `${newBaseUrl}${category.image_url}`
      : "path/to/default-image.jpg";

    setAddMainCatigory({
      icon_url: "",
      fileUrl: fullImageUrl,
      name: category.name,
      description: category.description,
      status: category.status,
    });
    setValue("name", category.name);
    setValue("description", category.description);
    setValue("status", category.status);
    setIsEditing(true);
    setEditCategoryId(category.id);
    setShow(true);
  };

  const [isSubCategory, setIsSubCategory] = useState(false);

  const [parentId, setParentId] = useState(false);

  const handleShowSubCategory = (id) => {
    setAddMainCatigory({
      image: "",
      fileUrl: "",
      name: "",
      description: "",
      status: "",
    });
    setIsSubCategory(true);
    setParentId(id);
    setShow(true);
  };

  const [showDelete, setShowDelete] = useState(false);

  const handleDeleteClose = () => {
    setShowDelete(false);
    setEditCategoryId(null);
    handleClose();
  };

  const confirmDelete = (id) => {
    setShowDelete(true);
    setEditCategoryId(id);
  };

  const deleteCategory = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/categories/${editCategoryId}`,
        {
          headers,
        }
      );
      toast.warning("Category Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getCategories();
    } catch (error) {
      toast.error("Failed To Delete This Category.");
      console.log(error.message);
    }
  };

  const navigate = useNavigate();

  const goToCatgoryProfile = (id) => {
    navigate(`/Categories/${id}`);
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();

  useEffect(() => {
    getCategories();
  }, []);

  // categories

  return (
    <>
      {/* delete catgory */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this category?"}
        deleteFunction={deleteCategory}
      />
      {/* add & edit (Main & sub) */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isEditing
              ? "Edit Main Category"
              : isSubCategory
              ? "Add Sub Category"
              : "Add Main Category"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddMainCatogiry)}>
            {/* image  */}
            <div className="flex-center-x-y">
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                {...register("image")}
                id="icon_url"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const allowedTypes = [
                      "image/jpeg",
                      "image/png",
                      "image/jpg",
                      "image/gif",
                      "image/svg+xml",
                    ];
                    if (allowedTypes.includes(file.type)) {
                      const imageUrl = URL.createObjectURL(file);
                      setAddMainCatigory({
                        ...addMainCatigory,
                        image: file,
                        fileUrl: imageUrl,
                      });
                    } else {
                      toast.error(
                        "Please select a valid image file (jpeg, png, jpg, gif, svg)."
                      );
                      setAddMainCatigory({
                        ...addMainCatigory,
                        image: "",
                        fileUrl: "",
                      });
                    }
                  }
                }}
              />
              <label htmlFor="icon_url" className="categories_photo">
                {addMainCatigory.fileUrl ? (
                  <img
                    className="categories-add"
                    src={addMainCatigory.fileUrl}
                    alt="Selected"
                  />
                ) : (
                  <img
                    src={addMainCatigory.fileUrl || AddPhoto}
                    alt="Category"
                  />
                )}
                <div className="categories_cameraIcon">
                  <img src={Camera} alt="" />
                </div>
              </label>
              {errors.image && <p className="danger">{errors.image.message}</p>}
            </div>
            {/* name */}
            <div className="row">
              <div className="col-12">
                <TextField
                  className="w-100 mb-3"
                  label="Category Name"
                  variant="outlined"
                  {...register("name")}
                  value={addMainCatigory.name}
                  onChange={(e) => {
                    setAddMainCatigory({
                      ...addMainCatigory,
                      name: e.target.value,
                    });
                  }}
                />
                {errors.name && <p className="danger">{errors.name.message}</p>}
              </div>
              {/* <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  label="Category Background"
                  variant="outlined"
                  {...register("background_color")}
                  value={addMainCatigory.background_color}
                  onChange={(e) => {
                    setAddMainCatigory({
                      ...addMainCatigory,
                      background_color: e.target.value,
                    });
                  }}
                />
                {errors.background_color && (
                  <p className="danger">{errors.background_color.message}</p>
                )}
              </div> */}
            </div>
            {/* description  */}
            <TextField
              className="w-100 mb-3"
              label="Category Description"
              variant="outlined"
              rows={4}
              multiline
              {...register("description")}
              value={addMainCatigory.description}
              onChange={(e) => {
                setAddMainCatigory({
                  ...addMainCatigory,
                  description: e.target.value,
                });
              }}
            />
            {errors.description && (
              <p className="danger">{errors.description.message}</p>
            )}
            {/* status  */}
            <div className="row">
              <div className="col-12">
                <FormControl className="w-100 mb-3" variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    label="Status"
                    {...register("status")}
                    value={addMainCatigory.status}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        status: e.target.value,
                      });
                    }}
                  >
                    <MenuItem className="custom-menu-item" value="active">
                      Active
                    </MenuItem>
                    <MenuItem className="custom-menu-item" value="inactive">
                      Inactive
                    </MenuItem>
                  </Select>
                </FormControl>
                {errors.status && (
                  <p className="danger">{errors.status.message}</p>
                )}
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* Categories Head */}
      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mx-4 my-3">
        <p className="fs-4 fw-bold my-0">Categories</p>
        <div
          className="d-flex align-items-center gap-2 px-3 py-2 border border-1 rounded-3 cursor"
          style={{ backgroundColor: "#f8f9fa" }}
          onClick={handleShow}
        >
          <AddIcon />
          <span className="fw-semibold">Add Category</span>
        </div>
      </div>
      {/* Categories Cards */}
      <div className="mx-4 my-3 border border-1 rounded-3 p-4 vh-100">
        {categories && categories.length > 0 ? (
          <div className="row g-3">
            {categories.map((cat) => (
              <div
                key={cat.id}
                className="col-12 col-sm-6 col-lg-4"
                onClick={() => goToCatgoryProfile(cat.id)}
              >
                <div className="border border-1 rounded-4 shadow-sm h-100 cursor d-flex flex-column">
                  <div
                    className="d-flex justify-content-between align-items-center bg-light rounded-top-4 px-3 py-3"
                    style={{ height: "70px" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={`${newBaseUrl}${cat.image_url}`}
                        alt=""
                        style={{
                          width: "35px",
                          height: "35px",
                          objectFit: "cover",
                        }}
                      />
                      <p className="mb-0 fw-semibold fs-6 text-truncate">
                        {cat.name}
                      </p>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <AddOutlined
                        onClick={(e) => {
                          e.stopPropagation();
                          handleShowSubCategory(cat.id);
                        }}
                        className="text-muted cursor"
                      />
                      <EditOutlined
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditCategory(cat);
                        }}
                        className="text-muted cursor"
                      />
                      <DeleteOutline
                        onClick={(e) => {
                          e.stopPropagation();
                          confirmDelete(cat.id);
                        }}
                        className="text-danger cursor"
                      />
                    </div>
                  </div>
                  {cat.children && cat.children.length > 0 && (
                    <div className="px-3 py-2">
                      {cat.children.map((sub, index) => (
                        <p key={index} className="my-2 fw-semibold text-muted">
                          {sub.name}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <NotFound
              paragraphText={
                "No Categories yet. All your Categories will appear here once you get started."
              }
            />
          </div>
        )}
      </div>
    </>
  );
}
